import { render, staticRenderFns } from "./CommonNewPageContainer.vue?vue&type=template&id=2abc21e6"
import script from "./CommonNewPageContainer.vue?vue&type=script&lang=js"
export * from "./CommonNewPageContainer.vue?vue&type=script&lang=js"
import style0 from "./CommonNewPageContainer.vue?vue&type=style&index=0&id=2abc21e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports